import React from "react";

const sponsors = [
    {
        tier: "First Class",
        list: [
            {
                name: "College of Engineering",
                image: require("../img/sponsors/2025/um_engin.png"),
                url: "https://engin.umich.edu/",
            },
            {
                name: "Aerospace Engineering",
                image: require("../img/sponsors/2025/um_aero.jpg"),
                url: "https://aero.engin.umich.edu/",
            },
            {
                name: "Office of the President",
                image: require("../img/sponsors/2025/office_of_prez.png"),
                url: "https://president.umich.edu/",
            },
            {
                name: "FXB Flight Vehicle Institute",
                image: require("../img/sponsors/2025/fxb.png"),
                url: "https://fxbfvi.engin.umich.edu/",
            }
        ],
    },
    {
        tier: "Business Class",
        list: [
            {
                name: "Northrop Grumman",
                image: require("../img/sponsors/2025/northrop_grumman.png"),
                url: "https://www.northropgrumman.com/",
            },
            {
                name: "Boeing",
                image: require("../img/sponsors/2025/boeing.png"),
                url: "https://www.boeing.com/",
            },
            {
                name: "Siemens",
                image: require("../img/sponsors/2025/siemens.png"),
                url: "https://www.siemens.com/global/en.html",
            },
            {
                name: "General Atomics",
                image: require("../img/sponsors/2025/general_atomic_new.png"),
                url: "https://www.ga.com/",
            },
            {
                name: "Blue Origin",
                image: require("../img/sponsors/2025/blue_origin.png"),
                url: "https://www.blueorigin.com/",
            },
        ],
    },
    {
        tier: "Coach Class",
        list: [
            {
                name: "dSpace",
                image: require("../img/sponsors/2025/dspace.png"),
                url: "https://www.dspace.com/en/inc/home.cfm",
            },
            {
                name: "Ford",
                image: require("../img/sponsors/2025/ford.png"),
                url: "https://www.ford.com/",
            },
            {
                name: "Keysight",
                image: require("../img/sponsors/2025/keysight_new.png"),
                url: "https://www.keysight.com/us/en/home.html",
            },
            {
                name: "College of Mechanical Engineering",
                image: require("../img/sponsors/2025/um_meche.png"),
                url: "https://me.engin.umich.edu/",
            },
            {
                name: "AeroVironment",
                image: require("../img/sponsors/2025/aerovironment.png"),
                url: "https://www.avinc.com/",
            },
            {
                name: "ESG",
                image: require("../img/sponsors/2025/esg.png"),
                url: "https://esg.engin.umich.edu/",
            },
            {
                name: "Easy Composites",
                image: require("../img/sponsors/2025/easy_composites.jpg"),
                url: "https://www.easycomposites.us/",
            },
            {
                name: "Hawkeye Industries",
                image: require("../img/sponsors/2025/hawkeye.png"),
                url: "https://hawkeyeind.com/",
            }
        ],
    },
];

export default sponsors;